const copilot32 = {
    svg: '<svg style="width:2.00rem; height:2.00rem;" viewBox="0 0 200 200"><rect width="100" height="200"/></svg>',
};

export { copilot32 as default };
